<template>
  <v-card
    flat
    outlined
    rounded="lg"
    height="100%"
    color="cardbg"
    class="flex"
    elevation="10"
  >
    <v-card-title
      color="primary"
      :style="`padding: calc(${scale} * 0.4rem);
        line-height: calc(${scale} * 0.75rem);
        font-size: calc(${scale} * 0.7rem);`"
      class="font-weight-medium d-flex justify-space-between"
    >
      <span class="titlecolor--text">
        {{ title }}
      </span>
      <span class="subtitlecolor--text">{{ daterange }}</span>
    </v-card-title>
    <v-card-text
      :style="`padding: calc(${scale} * 0.25rem);`"
      style="height: 90%; line-height: normal;"
    >
      <WidgetLoading v-if="loading" />
      <highcharts
        :options="options"
        style="height: 100%; width: 100%;"
        :key="uuid"
        v-else
      ></highcharts>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import WidgetLoading from './WidgetLoading.vue';

export default {
  name: 'LineChart',

  props: {
    title: { type: String },
    daterange: { type: String },
    scale: { type: Number, default: 1 },
    unit: { type: String },
    loading: { type: Boolean, default: false },
  },
  components: { WidgetLoading },
  data() {
    return {
      uuid: 'uuid',
      options: {
        chart: {
          type: 'line',
          style: {
            fontFamily: 'Poppins, "Open Sans", sans-serif',
          },
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true,
              style: { color: '#ffffff', textOutline: 'none' },
            },
            style: {
              fontFamily: 'Poppins, "Open Sans", sans-serif',
            },
          },
        },
        title: { text: '' },
        xAxis: {
          categories: [],
          labels: {
            style: { color: '#FFFFFF', marker: { radius: 8 } },
          },
          type: 'category',
          crosshair: true,
          title: { text: '' },
        },
        yAxis: {
          title: {
            text: '',
            style: { color: '#7AFC0B' },
          },
          labels: { style: { color: '#FFFFFF' } },
          gridLineColor: '#495767',
          plotBands: [],
        },
        legend: { enabled: false },
        series: [],
      },
    };
  },
  computed: {
    ...mapState('cellwiseQualityDashboard', ['theme']),
    ...mapGetters('cellwiseQualityDashboard', ['activeTheme']),
  },
  watch: {
    scale(val) {
      this.adjustSize(val);
      this.createUUID();
    },
  },
  mounted() {},
  methods: {
    assignData(result) {
      this.options.xAxis.categories = result.categories;
      this.options.series = result.series;
      this.options.yAxis.plotBands = result.plotBands;
      this.createUUID();
    },
    adjustSize(scale) {
      const lablesize = 8 * scale;
      const padding = 15 * scale;

      // const currentTheme = this.activeTheme || 'dark';

      // const subtitleColor = (this.theme && this.theme.themes && this.theme.themes[currentTheme])
      //   ? this.theme.themes[currentTheme].subtitlecolor
      //   : '#A1A3A5';

      const xlabels = {
        reserveSpace: true,
        y: padding,
        // style: { color: subtitleColor, fontSize: lablesize },
        style: {
          color: '#FFFFFF',
          fontSize: lablesize,
          fontFamily: 'Poppins, "Open Sans", sans-serif',
        },
      };
      const ylables = {
        // style: { color: subtitleColor, fontSize: lablesize },
        style: {
          color: '#FFFFFF',
          fontSize: lablesize,
          fontFamily: 'Poppins, "Open Sans", sans-serif',
        },
      };
      this.options.xAxis.labels = xlabels;
      this.options.yAxis.labels = ylables;
      this.options.plotOptions.series.dataLabels.style = {
        fontSize: lablesize,
        color: '#ffffff',
        textOutline: 'none',
        fontFamily: 'Poppins, "Open Sans", sans-serif',
      };
    },
    createUUID() {
      /* eslint-disable */
      var dt = new Date().getTime();
      var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = (dt + Math.random()*16)%16 | 0;
        dt = Math.floor(dt/16);
        return (c=='x' ? r :(r&0x3|0x8)).toString(16);
      });
      this.uuid =  uuid;
    },
  },
};
</script>

<style lang="scss" scoped>
.w-full {
  width: 100%;
}
.h-full {
  height: 100%;
}
</style>
